/* eslint-disable */
import React from 'react';
import { t } from '@web-solutions/module-localization';
import Analytics from '@web-solutions/module-analytics';
import { useNav } from 'src/onboarding/hooks/nav';
import { useStore } from 'src/onboarding/store/store';
import { Screen, Title, Subtitle, Options } from './Screen';
import { OptionCard } from './OptionCard';
import { trackFromGender, img } from './hairstyle';
import styles from './SingleSelect.module.scss';

type Opt = { id: string; emoji?: string };

type Props = {
  page: string;            // route id, e.g. 'hairstyle-focus'
  progress: number;
  field: string;           // store field, e.g. 'hairstyleFocus'
  setter: string;          // store setter, e.g. 'setHairstyleFocus'
  ns: string;              // localization namespace, e.g. 'hairstyleFocus'
  options: Opt[];
  hasSubtitle?: boolean;
  /** optional full-width photo between the text and the options (asset name under male/) */
  imageName?: string;
  /** map the raw option id to a stored value (e.g. gender → imageTrack) */
  mapValue?: (id: string) => any;
};

/** Generic single-select question — tap an option to record it and auto-advance. */
export const SingleSelect: React.FC<Props> = ({ page, progress, field, setter, ns, options, hasSubtitle, imageName, mapValue }) => {
  const value = useStore((s: any) => s[field]) as string | undefined;
  const setValue = useStore((s: any) => s[setter]) as (v: any) => void;
  const gender = useStore((s: any) => s.hairstyleGender);
  const { onNext, onPrev, currentIndex } = useNav();
  const image = imageName ? img(trackFromGender(gender), imageName) : undefined;

  const handleSelect = (id: string) => {
    setValue(mapValue ? mapValue(id) : id);
    Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', { page, answer: id });
    setTimeout(() => onNext(), 200);
  };

  const selectedId = mapValue
    ? options.find((o) => mapValue(o.id) === value)?.id
    : value;

  return (
    <Screen progress={progress} hideBack={currentIndex === 0} onBack={onPrev}>
      <Title>{t(`${ns}.title`)}</Title>
      {hasSubtitle && <Subtitle>{t(`${ns}.subtitle`)}</Subtitle>}
      {imageName && (
        <div className={styles.image}>
          {image ? <img src={image} alt="" className={styles.imageImg} /> : <div className={styles.imagePh} aria-hidden="true" />}
        </div>
      )}
      <Options>
        {options.map((opt) => (
          <OptionCard
            key={opt.id}
            mode="single"
            emoji={opt.emoji}
            label={t(`${ns}.options.${opt.id}`)}
            selected={selectedId === opt.id}
            onClick={() => handleSelect(opt.id)}
          />
        ))}
      </Options>
    </Screen>
  );
};

export default SingleSelect;
